import HeaderModal from "../headerModal/headerModal";
import {
  Container,
  ModalBody,
  IframeWrapper,
  PdfFrame,
  Controls,
  ControlButton,
  ScaleBox,
} from "./localStyle";

/*
  Componente: PDFViewer
  Descripción: Muestra un PDF dentro de un modal para tablet/desktop. Permite al paciente visualizar
  la orden sin abandonar el flujo actual. Recibe una URL (blob/objectURL) y título opcional.
*/
import { useState } from "react";

const PDFViewer = ({ url, titulo = "", dissmiss }) => {
  const [zoom, setZoom] = useState(1);

  const increase = () => setZoom((z) => Math.min(2.5, +(z + 0.1).toFixed(2)));
  const decrease = () => setZoom((z) => Math.max(0.6, +(z - 0.1).toFixed(2)));
  const reset = () => setZoom(1);

  return (
    <Container>
      <HeaderModal titulo={titulo || "Orden digital"} dissmiss={dissmiss} />
      <ModalBody>
        <Controls>
          <ControlButton onClick={decrease} aria-label="Disminuir zoom">
            -
          </ControlButton>
          <ControlButton onClick={reset} aria-label="Restablecer zoom">
            100%
          </ControlButton>
          <ControlButton onClick={increase} aria-label="Aumentar zoom">
            +
          </ControlButton>
        </Controls>
        <IframeWrapper>
          {/* Iframe dentro de un contenedor escalable para simular zoom */}
          <ScaleBox zoom={zoom}>
            <PdfFrame src={url} title="Visor de PDF" />
          </ScaleBox>
        </IframeWrapper>
      </ModalBody>
    </Container>
  );
};

export default PDFViewer;
